import { Button } from "@brightagency/headstart-common";
import React from "react";
import { Link } from "react-router-dom";
import { useGlobalLinks } from "../../../services/app-state";
import { useAssessmentState } from "../../../services/assessment-state";
import { getAcfPostUrl } from "../../../utils";
import { Wrapper, Content, Title, ButtonContainer } from "./styled";

export const SavedAssessmentResults: React.FC = () => {
    const [, { getGlobalLink }] = useGlobalLinks();
    const { reset } = useAssessmentState();
    const nswtbPage = getGlobalLink("not_sure_where_to_begin_page");

    return (
        <Wrapper>
            <Content>
                <Title>Your ‘Not sure where to begin?’ results</Title>
            </Content>
            <ButtonContainer>
                <Button appearance="secondary" to={getAcfPostUrl(nswtbPage)}>
                    See your results
                </Button>
                <Link to={getAcfPostUrl(nswtbPage)} onClick={reset}>
                    Start over
                </Link>
            </ButtonContainer>
        </Wrapper>
    );
};
